export default {
  title: 'Buchungsverfügbarkeiten',
};
